import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from '../../../constants/apiConfig';
import { useActualIncidentId } from './commonHooks';
import { toast } from 'react-toastify';
import {
  UpdateSafetyMessageRequestBody,
  SafetyMessageDto,
} from '../../../types/iapBaseTypes';
import { keys } from './useCreateSafetyMessage';

export const useUpdateSafetyMessage = () => {
  const queryClient = useQueryClient();
  const incidentId = useActualIncidentId();

  return useMutation({
    mutationFn: async ({
      id,
      data,
    }: {
      id: string;
      data: UpdateSafetyMessageRequestBody;
    }) => {
      const payload: UpdateSafetyMessageRequestBody = {
        ...data,
        incidentId: incidentId,
      };

      const response = await axios.put<SafetyMessageDto>(
        `${config.apiGateway.ics_safety_messages}/${id}`,
        payload
      );
      return response.data;
    },
    onSuccess: (_, { id }) => {
      if (incidentId) {
        queryClient.invalidateQueries({
          queryKey: [keys.safetyMessages, incidentId],
        });
        queryClient.invalidateQueries({ queryKey: [keys.safetyMessages, id] });
      }
      toast.success('Safety plan updated successfully');
    },
    onError: (error: any) => {
      const errorMessage =
        error.response?.data?.error || 'Failed to update safety plan';
      toast.error(errorMessage);
    },
  });
};
